/* OllYou Motion — scroll choreography + quick-add
   One file, no dependencies. Every effect respects prefers-reduced-motion
   and degrades to fully visible content when JS or IO is unavailable. */
(function () {
  'use strict';

  var docEl = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ================================================================
     QUICK ADD (runs regardless of motion preference)
     ================================================================ */
  function updateCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badge = document.querySelector('.header__cart-count');
        var cartLink = document.querySelector('.header__cart');
        if (badge) {
          badge.textContent = cart.item_count;
        } else if (cartLink && cart.item_count > 0) {
          badge = document.createElement('span');
          badge.className = 'header__cart-count';
          badge.textContent = cart.item_count;
          cartLink.appendChild(badge);
        }
        if (badge) {
          badge.classList.remove('cart-count-pop');
          void badge.offsetWidth;
          badge.classList.add('cart-count-pop');
        }
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quick-add[data-variant-id]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    btn.classList.add('is-adding');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(btn.dataset.variantId, 10), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        btn.classList.remove('is-adding');
        btn.classList.add('is-added');
        var label = btn.querySelector('.quick-add__label');
        if (label) label.textContent = 'Added ✓';
        updateCartCount();
        setTimeout(function () {
          btn.classList.remove('is-added');
          if (label) label.textContent = 'Quick Add';
          btn.disabled = false;
        }, 2200);
      })
      .catch(function () {
        btn.classList.remove('is-adding');
        btn.disabled = false;
        window.location.href = btn.closest('.product-card')
          ? btn.closest('.product-card').querySelector('a').href
          : '/cart';
      });
  });

  if (reduceMotion) return; // everything below is motion

  docEl.classList.add('js-motion');

  /* ================================================================
     1 · REVEAL CHOREOGRAPHY
     Each section gets its own entrance — assigned here, not uniform.
     ================================================================ */
  function tag(el, variant, index) {
    if (!el) return;
    el.classList.add('mo', 'mo--' + variant);
    if (typeof index === 'number') el.style.setProperty('--mo-i', index);
  }

  function tagAll(list, variant) {
    Array.prototype.forEach.call(list, function (el, i) { tag(el, variant, i); });
  }

  /* Hero — masked rises, then chips fade through */
  tagAll(document.querySelectorAll('.hero-split__kicker, .hero-split__title, .hero-split__subtitle, .hero-split__proof, .hero-split__buy'), 'mask-rise');
  tagAll(document.querySelectorAll('.hero-split__chip'), 'pop');
  tag(document.querySelector('.hero-split__visual'), 'hero-visual');

  /* Proof bar — stats rise in sequence (count-up handled below) */
  tagAll(document.querySelectorAll('.proof-bar__item'), 'rise');

  /* Featured product — image wipes open, copy cascades from the right */
  tag(document.querySelector('.featured__media'), 'wipe-right');
  tagAll(document.querySelectorAll('.featured__info > *'), 'slide-left');

  /* How it works (dark band) — the band itself wipes up over the page */
  tag(document.querySelector('.hiw'), 'curtain');
  tagAll(document.querySelectorAll('.hiw__step'), 'rise');

  /* Before & after — header rises; the wipe itself is scroll-driven below */
  tagAll(document.querySelectorAll('.ba__header > *'), 'rise');
  tag(document.querySelector('.ba__slider'), 'scale-in');

  /* Suitable for — cards tilt up one by one */
  tagAll(document.querySelectorAll('.sf__card'), 'tilt-rise');
  tagAll(document.querySelectorAll('.sf__header > *'), 'rise');

  /* Features + comparison — cascade */
  tagAll(document.querySelectorAll('.clip-features__card'), 'rise');
  tagAll(document.querySelectorAll('.clip-features__vs-row'), 'slide-left');

  /* Testimonials — alternating tilt */
  Array.prototype.forEach.call(document.querySelectorAll('.ollyou-proof__card'), function (el, i) {
    tag(el, i % 2 ? 'tilt-rise-r' : 'tilt-rise', i);
  });

  /* Guarantee — swells in */
  tag(document.querySelector('.ollyou-guarantee__inner'), 'scale-in');

  /* FAQ — items stagger */
  tagAll(document.querySelectorAll('.faq__item'), 'rise');

  /* Collection carousel — slides sweep in from the right */
  tagAll(document.querySelectorAll('.carousel__slide'), 'slide-left');

  /* Brand story — soft scale */
  tag(document.querySelector('.brand-story__inner'), 'scale-in');

  /* NOTE (live theme): .reveal elements are handled by the theme's existing
     inline IntersectionObserver script — deliberately not tagged here to
     avoid double-gating their visibility. */

  /* Reveal engine: driven from the same rAF/scroll loop as the parallax
     layer below (checkReveals). No IntersectionObserver — deterministic in
     every rendering environment, and ~60 rect reads per frame is cheap. */
  var pendingReveals = Array.prototype.slice.call(document.querySelectorAll('.mo'));

  function checkReveals(vh) {
    if (!pendingReveals.length) return;
    var threshold = vh * 0.92;
    pendingReveals = pendingReveals.filter(function (el) {
      /* anything at or above the trigger line reveals — including elements
         jumped past via anchor links or fast scrolls */
      if (el.getBoundingClientRect().top < threshold) {
        el.classList.add('mo-in');
        return false;
      }
      return true;
    });
  }

  /* ================================================================
     2 · COUNT-UP for proof-bar stats ("120+", "4.8 ★", "30s", "94%")
     ================================================================ */
  function countUp(el) {
    var raw = el.textContent.trim();
    var m = raw.match(/^([\d,]*\.?\d+)(.*)$/);
    if (!m) return;
    var target = parseFloat(m[1].replace(/,/g, ''));
    var suffix = m[2] || '';
    var decimals = (m[1].split('.')[1] || '').length;
    var t0 = null;
    var dur = 1400;
    function frame(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 4);
      var val = (target * eased).toFixed(decimals);
      el.textContent = Number(val).toLocaleString(undefined, {
        minimumFractionDigits: decimals, maximumFractionDigits: decimals
      }) + suffix;
      if (p < 1) requestAnimationFrame(frame);
      else el.textContent = raw;
    }
    requestAnimationFrame(frame);
  }

  var pendingStats = Array.prototype.slice.call(document.querySelectorAll('.proof-bar__value'));

  function checkStats(vh) {
    if (!pendingStats.length) return;
    pendingStats = pendingStats.filter(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < vh * 0.85 && rect.bottom > 0) {
        countUp(el);
        return false;
      }
      return true;
    });
  }

  /* ================================================================
     3 · SCROLL-LINKED LAYER (one rAF loop, passive listeners)
     - hero parallax (product floats slower than the page)
     - sticker ring rotates with scroll
     - marquee skews with scroll velocity
     - before/after wipes itself as you scroll past (until touched)
     ================================================================ */
  var heroVisual = document.querySelector('.hero-split__visual');
  var heroImg = document.querySelector('.hero-split__img');
  var heroBlob = document.querySelector('.hero-split__blob');
  var sticker = document.querySelector('.hero-split__sticker svg');
  /* skew the wrapper, not the track — the track's transform belongs to the
     marquee keyframe animation */
  var marqueeTrack = document.querySelector('.marquee');
  var baEl = document.querySelector('.ba__slider');
  var baAfter = baEl ? baEl.querySelector('.ba__pane--after') : null;
  var baLine = baEl ? baEl.querySelector('.ba__line') : null;
  var baUserTouched = false;

  if (baEl) {
    ['mousedown', 'touchstart'].forEach(function (evt) {
      baEl.addEventListener(evt, function () { baUserTouched = true; }, { passive: true, once: true });
    });
  }

  if (sticker) sticker.style.animation = 'none'; // scroll drives it instead

  var lastY = window.scrollY;
  var velocity = 0;
  var smoothVel = 0;
  var ticking = false;

  /* rAF normally; timeout fallback covers webviews with a stalled
     compositor so reveals can never dead-end */
  function schedule() {
    if (ticking) return;
    ticking = true;
    var ran = false;
    requestAnimationFrame(function () {
      if (ran) return;
      ran = true;
      update();
    });
    setTimeout(function () {
      if (ran) return;
      ran = true;
      update();
    }, 120);
  }

  function onScroll() {
    velocity = window.scrollY - lastY;
    lastY = window.scrollY;
    schedule();
  }

  function update() {
    ticking = false;
    var y = window.scrollY;
    var vh = window.innerHeight;

    checkReveals(vh);
    checkStats(vh);

    /* hero parallax — only while the hero is on screen */
    if (heroVisual && y < vh * 1.2) {
      if (heroImg) heroImg.style.translate = '0 ' + (y * 0.1).toFixed(1) + 'px';
      if (heroBlob) heroBlob.style.translate = '0 ' + (y * -0.06).toFixed(1) + 'px';
    }

    /* sticker ring — one full turn per 1200px scrolled, plus a slow idle base */
    if (sticker) {
      sticker.style.transform = 'rotate(' + (-(y * 0.3) % 360).toFixed(1) + 'deg)';
    }

    /* marquee skew — leans into the scroll, springs back when you stop */
    smoothVel += (velocity - smoothVel) * 0.12;
    if (marqueeTrack) {
      var skew = Math.max(-4, Math.min(4, smoothVel * 0.35));
      marqueeTrack.style.transform = 'skewX(' + skew.toFixed(2) + 'deg)';
    }

    /* before/after scroll wipe — reveals the "after" as the section passes */
    if (baEl && baAfter && baLine && !baUserTouched) {
      var rect = baEl.getBoundingClientRect();
      if (rect.top < vh && rect.bottom > 0) {
        var progress = 1 - (rect.top + rect.height * 0.5) / (vh + rect.height * 0.5);
        progress = Math.max(0, Math.min(1, progress));
        var pct = 78 - progress * 56; /* sweeps 78% -> 22%: oily fades, fresh takes over */
        baAfter.style.clipPath = 'inset(0 0 0 ' + pct.toFixed(1) + '%)';
        baLine.style.left = pct.toFixed(1) + '%';
      }
    }

    /* decay velocity so the marquee always settles upright */
    if (Math.abs(smoothVel) > 0.05) {
      velocity *= 0.8;
      schedule();
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  window.addEventListener('load', update);
  update();
})();
